import Phaser from 'phaser';

/** `?hitdebug=1` draws every button's tap area, for verifying hit zones. */
export const HIT_DEBUG =
  typeof location !== 'undefined' && new URLSearchParams(location.search).has('hitdebug');

/**
 * Make a circle Shape a reliable circular tap target.
 *
 * Input is attached to the shape itself, not to a parent Container: a
 * Container's custom hit-area uses a different local-origin convention, which
 * silently shifts the clickable region away from the visible button. A Shape
 * has well-defined geometry, so the tap area lines up with what's drawn.
 */
export function makeCircleButton(
  scene: Phaser.Scene,
  shape: Phaser.GameObjects.Shape,
  r: number,
  onPress: () => void,
): void {
  shape.setInteractive(new Phaser.Geom.Circle(r, r, r), Phaser.Geom.Circle.Contains);
  shape.on('pointerdown', onPress);
  if (HIT_DEBUG) scene.input.enableDebug(shape, 0xff3344);
}
